import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import SoepPage from "./pages/SoepPage";
import DocumentationPage from "./pages/DocumentationPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminSettingsPage from "./pages/AdminSettingsPage";
import UserSettingsPage from "./pages/UserSettingsPage";
import UserManualPage from "./pages/UserManualPage";
import PatientSharePage from "./pages/PatientSharePage";
import LiveTranscriptPage from "./pages/LiveTranscriptPage";

const queryClient = new QueryClient();

/**
 * Een data router, en niet `<BrowserRouter><Routes>`.
 *
 * De routes zijn dezelfde -- er zijn geen loaders of actions, en er is geen reden om
 * die erbij te halen. Wat deze vorm wél biedt is useBlocker, en dat is het enige
 * aangrijpingspunt om een navigatie binnen de applicatie tegen te houden. Zonder
 * blocker verdwijnt een lopend consult zodra iemand op het tandwiel of de
 * terugknop van de browser drukt: het opnamescherm unmount, en het transcript staat
 * nergens anders dan in dat component. Zie components/VerlatenWaarschuwing.tsx.
 */
const router = createBrowserRouter([
  { path: '/', element: <SoepPage /> },
  { path: '/soep', element: <SoepPage /> },
  { path: '/settings', element: <UserSettingsPage /> },
  { path: '/handleiding', element: <UserManualPage /> },
  { path: '/patient-share/:token', element: <PatientSharePage /> },
  { path: '/live/:token', element: <LiveTranscriptPage /> },
  { path: '/admin/login', element: <AdminLoginPage /> },
  { path: '/admin', element: <AdminSettingsPage /> },
  { path: '/admin/docs', element: <DocumentationPage /> },
]);

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <RouterProvider router={router} />
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
